import React, { useState } from "react";

import {
  Pagination,
  SearchUsersResponse,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

import { DEFAULT_TABLE_PAGINATION } from "../constants/index";
import { RegionSearchUser, UserSearchQuery } from "../types/search-display";
import {
  AuUserSearchContext,
  EuUserSearchContext,
  UsUserSearchContext,
  UserSearchQueryContext,
} from "./user-search-context";

interface UserSearchContextProps {
  children: React.ReactNode;
}

const UserSearchContextWrapper = ({ children }: UserSearchContextProps) => {
  const [userSearchQueryState, setUserSearchQueryState] =
    useState<UserSearchQuery>({
      firstName: "",
      lastName: "",
      emailLocal: "",
      emailDomain: "",
      userId: "",
      matchExactEmail: false,
    });

  const [usRegionSearchUsers, setUsRegionSearchUsers] =
    useState<RegionSearchUser>({
      usersSearchResp: new SearchUsersResponse({
        users: [],
        totalItems: 0,
      }),
      pagination: new Pagination({
        pageSize: DEFAULT_TABLE_PAGINATION,
        offset: 0,
      }),
      isLoading: false,
    });

  const [euRegionSearchUsers, setEuRegionSearchUsers] =
    useState<RegionSearchUser>({
      usersSearchResp: new SearchUsersResponse({
        users: [],
        totalItems: 0,
      }),
      pagination: new Pagination({
        pageSize: DEFAULT_TABLE_PAGINATION,
        offset: 0,
      }),
      isLoading: false,
    });

  const [auRegionSearchUsers, setAuRegionSearchUsers] =
    useState<RegionSearchUser>({
      usersSearchResp: new SearchUsersResponse({
        users: [],
        totalItems: 0,
      }),
      pagination: new Pagination({
        pageSize: DEFAULT_TABLE_PAGINATION,
        offset: 0,
      }),
      isLoading: false,
    });

  const userSearchQueryContextValue = {
    userSearchQueryState,
    setUserSearchQueryState,
  };

  const usUserSearchContextValue = {
    usRegionSearchUsers,
    setUsRegionSearchUsers,
  };
  const euUserSearchContextValue = {
    euRegionSearchUsers,
    setEuRegionSearchUsers,
  };
  const auUserSearchContextValue = {
    auRegionSearchUsers,
    setAuRegionSearchUsers,
  };

  return (
    <UserSearchQueryContext.Provider value={userSearchQueryContextValue}>
      <UsUserSearchContext.Provider value={usUserSearchContextValue}>
        <EuUserSearchContext.Provider value={euUserSearchContextValue}>
          <AuUserSearchContext.Provider value={auUserSearchContextValue}>
            {children}
          </AuUserSearchContext.Provider>
        </EuUserSearchContext.Provider>
      </UsUserSearchContext.Provider>
    </UserSearchQueryContext.Provider>
  );
};

export default UserSearchContextWrapper;
